// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccesoRouteImport } from './routes/acceso'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as CuentaRouteImport } from './routes/cuenta'
import { Route as PodcastRouteImport } from './routes/podcast'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as LegalCookiesRouteImport } from './routes/legal.cookies'
import { Route as LegalLicenciaRouteImport } from './routes/legal.licencia'
import { Route as LegalPrivacidadRouteImport } from './routes/legal.privacidad'
import { Route as LegalReembolsosRouteImport } from './routes/legal.reembolsos'
import { Route as LegalTerminosRouteImport } from './routes/legal.terminos'
import { Route as PodcastEpisodeSlugRouteImport } from './routes/podcast_.$episodeSlug'
import { Route as ProductosIndexRouteImport } from './routes/productos.index'
import { Route as ProductosProductIdRouteImport } from './routes/productos.$productId'
import { Route as ProductosCarritoRouteImport } from './routes/productos.carrito'
import { Route as ProductosCatalogoRouteImport } from './routes/productos.catalogo'
import { Route as ProductosGraciasRouteImport } from './routes/productos.gracias'
import { Route as ProductosMisComprasRouteImport } from './routes/productos.mis-compras'
import { Route as ProductosTicketsRouteImport } from './routes/productos.tickets'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccesoRoute = AccesoRouteImport.update({
            id: '/acceso',path: '/acceso',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const CuentaRoute = CuentaRouteImport.update({
            id: '/cuenta',path: '/cuenta',getParentRoute: () => rootRouteImport
          })
const PodcastRoute = PodcastRouteImport.update({
            id: '/podcast',path: '/podcast',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const LegalCookiesRoute = LegalCookiesRouteImport.update({
            id: '/legal/cookies',path: '/legal/cookies',getParentRoute: () => rootRouteImport
          })
const LegalLicenciaRoute = LegalLicenciaRouteImport.update({
            id: '/legal/licencia',path: '/legal/licencia',getParentRoute: () => rootRouteImport
          })
const LegalPrivacidadRoute = LegalPrivacidadRouteImport.update({
            id: '/legal/privacidad',path: '/legal/privacidad',getParentRoute: () => rootRouteImport
          })
const LegalReembolsosRoute = LegalReembolsosRouteImport.update({
            id: '/legal/reembolsos',path: '/legal/reembolsos',getParentRoute: () => rootRouteImport
          })
const LegalTerminosRoute = LegalTerminosRouteImport.update({
            id: '/legal/terminos',path: '/legal/terminos',getParentRoute: () => rootRouteImport
          })
const PodcastEpisodeSlugRoute = PodcastEpisodeSlugRouteImport.update({
            id: '/podcast_/$episodeSlug',path: '/podcast/$episodeSlug',getParentRoute: () => rootRouteImport
          })
const ProductosIndexRoute = ProductosIndexRouteImport.update({
            id: '/productos/',path: '/productos/',getParentRoute: () => rootRouteImport
          })
const ProductosProductIdRoute = ProductosProductIdRouteImport.update({
            id: '/productos/$productId',path: '/productos/$productId',getParentRoute: () => rootRouteImport
          })
const ProductosCarritoRoute = ProductosCarritoRouteImport.update({
            id: '/productos/carrito',path: '/productos/carrito',getParentRoute: () => rootRouteImport
          })
const ProductosCatalogoRoute = ProductosCatalogoRouteImport.update({
            id: '/productos/catalogo',path: '/productos/catalogo',getParentRoute: () => rootRouteImport
          })
const ProductosGraciasRoute = ProductosGraciasRouteImport.update({
            id: '/productos/gracias',path: '/productos/gracias',getParentRoute: () => rootRouteImport
          })
const ProductosMisComprasRoute = ProductosMisComprasRouteImport.update({
            id: '/productos/mis-compras',path: '/productos/mis-compras',getParentRoute: () => rootRouteImport
          })
const ProductosTicketsRoute = ProductosTicketsRouteImport.update({
            id: '/productos/tickets',path: '/productos/tickets',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccesoRoute: AccesoRoute,ContactoRoute: ContactoRoute,CuentaRoute: CuentaRoute,PodcastRoute: PodcastRoute,AdminDashboardRoute: AdminDashboardRoute,LegalCookiesRoute: LegalCookiesRoute,LegalLicenciaRoute: LegalLicenciaRoute,LegalPrivacidadRoute: LegalPrivacidadRoute,LegalReembolsosRoute: LegalReembolsosRoute,LegalTerminosRoute: LegalTerminosRoute,PodcastEpisodeSlugRoute: PodcastEpisodeSlugRoute,ProductosProductIdRoute: ProductosProductIdRoute,ProductosCarritoRoute: ProductosCarritoRoute,ProductosCatalogoRoute: ProductosCatalogoRoute,ProductosGraciasRoute: ProductosGraciasRoute,ProductosMisComprasRoute: ProductosMisComprasRoute,ProductosTicketsRoute: ProductosTicketsRoute,LegalIndexRoute: LegalIndexRoute,ProductosIndexRoute: ProductosIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)